export default __webpack_public_path__ + "static/7-best-shopping-destinations-around-the-world-d4d9ef369f7278027b233b2dc73315a0.jpg";